<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>{{ title }}</v-card-title>
                <v-card-subtitle>{{ $t('TRUCK_MODEL_SUBTITLE') }}</v-card-subtitle>
                <v-card-text>
                    <div class="text-center" v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        v-if="!loading.data">
                            <v-text-field
                                :label="$t('MODEL_NAME')"
                                v-model="form.name"
                                :disabled="uneditableField('name')"
                                :rules="rules.name">
                            </v-text-field>
                            <v-autocomplete
                                :label="$t('GROUP_NAME')"
                                v-model="form.parent_truck_model_id"
                                :disabled="uneditableField('parent_truck_model_id')"
                                :items="truckModels"
                                item-text="name"
                                item-value="id"
                                clearable>
                            </v-autocomplete>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="submit"
                        :disabled="!valid || loading.data || loading.submit"
                        :loading="loading.submit">
                        {{ $t("BTN_SAVE") }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close"
                        class="mx-1">
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onSubmitRetryDailog"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import { mapActions,mapState } from 'vuex';
import RetryDialog from "../components/RetryDialog";
import uneditableField from '../utils/uneditableField';
import AlertDialog from '../components/AlertDialog';
export default {
    components:{
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            valid: false,
            editMode: false,
            id: null,
            form: {
                id: null,
                truck_brand_id: null,
                name: null,
                parent_truck_model_id: null
            },
            rules: {
                name: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed:{
        ...mapState("truckBrand", ["truckBrand","truckBrands"]),
        ...mapState("truckModel",["truckModels", "truckModel"]),
        title() {
            if(!this.editMode) return this.$t("NEW_MODEL");
            else return this.$t("EDIT_MODEL")
        }
    },
    methods:{
        uneditableField,
        ...mapActions("truckBrand", ["fetchTruckBrands"]),
        ...mapActions("truckModel", ["fetchTruckModels", "fetchTruckModel", "storeTruckModel", "updateTruckModel"]),
        open(params) {
            this.editMode = params.editMode;
            this.form.truck_brand_id = params.truck_brand_id;
            this.loading.data = true;
            this.openParams = params;
            this.display = true;
            this.openDataFetch(this.openParams);
        },
        async openDataFetch(params){
            try {
                if(this.editMode) {
                    await this.fetchTruckModel(params.id);
                    this.form = this.truckModel;
                }
                await this.fetchTruckModels({truck_brand_id: this.form.truck_brand_id});
                this.loading.data = false;
            } catch(error){
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target:'openDataFetch', message})
            }
        },
        onSubmitRetryDailog(params) {
            if(params.target == "openDataFetch") {
                if(params.retry == true) this.openDataFetch(this.openParams);
                else this.close();
            }
        },
        close() {
            this.display = false;
            this.loading.data = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeTruckModel(this.form)
                    .then(() => {
                        this.close();
                        this.fetchTruckModels({truck_brand_id: this.form.truck_brand_id});
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t("RECORD_SAVE_SUCCESS"));
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = null;
                        if(error.response) message = error.response.data.message;
                        else message = error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            } else {
                this.updateTruckModel(this.form)
                    .then(() => {
                        this.close();
                        this.fetchTruckModels({truck_brand_id: this.form.truck_brand_id});
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t("RECORD_UPDATE_SUCCESS"));
                    })
                    .catch(error => {
                        this.loading.submit = false;
                        let message = null;
                        if(error.response) message = error.response.data.message;
                        else message = error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            }
        }
    }
}
</script>